export function setSessionItem(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    console.error(`Error setting sessionStorage key "${key}":`, error);
  }
}

export function getSessionItem(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    console.error(`Error getting sessionStorage key "${key}":`, error);
    return null;
  }
}
